import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartOptions } from 'chart.js';

interface BarChartProps {
  data: number[];
}

const BarChartComponent: React.FC<BarChartProps> = ({ data }) => {
  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

  const monthlyPower = Array(12).fill(0);
  data.forEach((value, index) => {
    // convert hourly data into montly data
    const month: number = Math.floor(index / 730); // 730 hours in a month
    monthlyPower[month] += value;
  });

  const montlydata = {
    labels: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    datasets: [
      {
        label: 'Monatlicher Ertrag (kWh)',
        data: monthlyPower.map(value => (value / 1000).toFixed(2)), // Convert to kWh
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
    ],
  };

  const options: ChartOptions<"bar"> = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: false,
        text: 'Monatlicher Ertrag',
      },
    },
  };

  return <Bar data={montlydata} options={options} />;
};

export default BarChartComponent;
